import React from 'react';

import styles from '../compensationCardStyles';

import BriefcaseIcon from 'buyside/svgs/briefcase.svg';
import ClockIcon from 'buyside/svgs/clock.svg';
import PieChartIcon from 'buyside/svgs/pie_chart.svg';

import { formatCompensations } from 'buyside/util/formatNumber';

const CompensationCardTop = ({
  node: { title, location, experience, fundType, fundSize, year, category, totalCashComp }
}) => {
  return (
    <div className={styles.contentAreaTop}>
      <div className={styles.profileArea}>
        <div className={styles.title}>
          <h3>{title}</h3>
          <span>{location}</span>
        </div>
        <div className={styles.profileDetail}>
          <div className={styles.profileEach}>
            <div>
              <ClockIcon className={styles.icon} />
            </div>
            <div>
              <div className={styles.labelSmall}>Experience</div>
              <div>{experience}</div>
            </div>
          </div>
          <div className={styles.profileEach}>
            <div>
              <BriefcaseIcon className={styles.icon} />
            </div>
            <div>
              <div className={styles.labelSmall}>Firm Type</div>
              <div>{fundType}</div>
            </div>
          </div>
          <div className={styles.profileEach}>
            <div>
              <PieChartIcon className={styles.icon} />
            </div>
            <div>
              <div className={styles.labelSmall}>Fund Size</div>
              <div>{fundSize}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardStats}>
        <div>
          <div className={styles.statsNum}>{formatCompensations(totalCashComp)}</div>
          <div className={styles.statsText}>
            {year} {category} Total Compensation
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompensationCardTop;
